import ResumeItem from '@/common/components/ResumeItem'
import { formatPercentage } from '@/common/utils/formatters'
import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react'

interface ProposalAwareResumeItemProps {
  label: string
  originalValue: number
  newValue: number | null | undefined
  differencePercentage?: string | null
  format: (value: number) => string
}

const ProposalAwareResumeItem = ({
  label,
  originalValue,
  newValue,
  differencePercentage,
  format,
}: ProposalAwareResumeItemProps) => {
  const hasModification = newValue !== null && newValue !== undefined

  if (!hasModification) {
    return <ResumeItem className="text-sm" label={label} value={format(originalValue)} />
  }

  const newValueClassName = newValue > originalValue ? 'text-danger-soft' : newValue < originalValue ? 'text-valid' : ''

  const differencePercentageNumber = differencePercentage != null ? Number(differencePercentage) : null

  const showDifferencePercentage = differencePercentageNumber != null && differencePercentageNumber !== 0

  return (
    <ResumeItem
      className="text-sm"
      label={label}
      value={
        <span className="flex items-center gap-1">
          <span className={newValueClassName}>{format(newValue)}</span>

          <span className="text-xs text-white-400 line-through">{format(originalValue)}</span>

          {showDifferencePercentage && (
            <span className="text-[9px] text-white-800 rounded-full px-1 bg-yellow-op-2 inline-flex items-center">
              {differencePercentageNumber > 0 ? (
                <ArrowUpIcon className="size-3 text-danger-soft" />
              ) : (
                <ArrowDownIcon className="size-3 text-valid" />
              )}
              {formatPercentage(Math.abs(differencePercentageNumber))}
            </span>
          )}
        </span>
      }
    />
  )
}

export default ProposalAwareResumeItem
